import { gql } from '@apollo/client';

export const WORK_ORDERS_LIST = gql`
  query WorkOrdersList($sort: [WorkOrderSort!], $first: Int, $skip: Int) {
    workOrdersList(sort: $sort, first: $first, skip: $skip) {
      items {
        id
        title
        description
        category
        status
        dateOpened
        estimatedCompletionDate
        workOrderDetails
        repairNotes
        createdAt
        updatedAt
        deletedAt
       
        workOrders {
          id
          vIN
          model
          licensePlate
          make
          unitNumber
        }
        inspection {
          inspector
          notes
          startDate
          endDate
          id
          checklist
        }
        assignedTo {
          id
          firstName
          lastName
        }
        attachments {
          items {
            id
            downloadUrl
          }
        }
        createdBy {
          id
          firstName
          lastName
          email
        }
      }
      count
    }
  }
`;

export const WORK_ORDER_GET = gql`
  query WorkOrderGet($id: ID!) {
    workOrder(id: $id) {
      id
      title
      description
      category
      status
      dateOpened
      estimatedCompletionDate
      workOrderDetails
      repairNotes
      createdAt
      updatedAt
      deletedAt
      maintenance {
        id
        _description
      }
      workOrders {
        id
        vIN
        model
        licensePlate
        make
        unitNumber
      }
      inspection {
        inspector
        notes
        startDate
        endDate
        id
        checklist
      }
      assignedTo {
        id
        firstName
        lastName
      }
      attachments {
        items {
          id
          downloadUrl
        }
      }
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const WORK_ORDER_GET_LIST_FILTER = gql`
  query WorkOrderGet($id: ID!) {
    workOrdersList(filter: { id: { equals: $id } }) {
      items {
        id
        title
        description
        category
        status
        dateOpened
        estimatedCompletionDate
        workOrderDetails
        repairNotes
        createdAt
        updatedAt
        deletedAt
      
        workOrders {
          id
          vIN
          model
          licensePlate
          make
          unitNumber
        }
        inspection {
          inspector
          notes
          startDate
          endDate
          id
          checklist
        }
        assignedTo {
          id
          firstName
          lastName
        }
        attachments {
          items {
            id
            downloadUrl
          }
        }
        createdBy {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const WORK_ORDER_CREATE = gql`
  mutation WorkOrderCreate($data: WorkOrderCreateInput!) {
    workOrderCreate(data: $data) {
      id
      title
      description
      category
      status
      dateOpened
      workOrderDetails
      inspection {
        id
        inspector
        date
      }
      workOrders {
        id
        make
        model
        licensePlate
      }
    }
  }
`;

// Bulk work order creation mutation using workOrderCreateMany
export const WORK_ORDERS_BULK_CREATE = gql`
  mutation WorkOrdersBulkCreate($data: [WorkOrderCreateManyInput]!) {
    workOrderCreateMany(data: $data) {
      count
      __typename
    }
  }
`;

export const WORK_ORDER_UPDATE = gql`
  mutation WorkOrderUpdate($filter: WorkOrderKeyFilter!, $data: WorkOrderUpdateInput!) {
    workOrderUpdate(filter: $filter, data: $data) {
      id
    }
  }
`;

export const WORK_ORDER_DELETE = gql`
  mutation WorkOrderDestroy($filter: WorkOrderKeyFilter!) {
    workOrderDestroy(filter: $filter) {
      success
    }
  }
`; 